import { useTranslation } from 'react-i18next';
const LOGOS = [
  { name: "SAAS CO", tagline: "B2B SaaS" },
  { name: "SHOPDIRECT", tagline: "E-commerce" },
  { name: "GROWTHLAB", tagline: "Marketing Agency" },
  { name: "TECHFLOW", tagline: "Technology" },
  { name: "NEXGEN", tagline: "Consulting" },
  { name: "BRIGHTPATH", tagline: "Education" },
  { name: "APEX DIGITAL", tagline: "Digital Agency" },
  { name: "CLOUDNINE", tagline: "Cloud Services" },
  { name: "MOMENTUM", tagline: "Startup" },
  { name: "SYNERGY", tagline: "Enterprise" },
];

export default function LogosSection() {
  const { t } = useTranslation();
  return (
    <section className="border-t border-b border-zinc-800/50 bg-zinc-950/30 py-12" aria-labelledby="trusted-by-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Label */}
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-2" aria-hidden="true">
          // 05 / TRUSTED BY
        </div>

        {/* Headline */}
        <h2 id="trusted-by-heading" className="font-display text-3xl md:text-4xl uppercase leading-tight mb-2">
          Trusted by 33 businesses<br />
          <span className="text-zinc-500">across 12 countries</span>
        </h2>

        {/* Subheadline */}
        <p className="text-zinc-400 text-sm md:text-base leading-relaxed mb-10 max-w-2xl">{t('logos_section.from_startups_to_enterprises_businesses_rely_on')}</p>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {LOGOS.map((logo) => (
            <div
              key={logo.name}
              className="group flex flex-col items-center justify-center border border-zinc-800/50 bg-zinc-950/50 py-6 px-4 transition-all duration-300 hover:border-amber-500/30 hover:bg-amber-500/5"
            >
              <span className="font-display text-xl uppercase tracking-wider text-zinc-600 transition-all duration-300 group-hover:text-amber-500">
                {logo.name}
              </span>
              <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-zinc-700 mt-1 transition-all duration-300 group-hover:text-zinc-500">
                {logo.tagline}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
